export const JEWELRY_CATEGORIES = ['jewelry', 'fine-jewelry', 'fashion-jewelry'];
